'use client'

import { useMemo } from 'react'

import { NostoProductRecommendationsSection } from '../../../brunswick/components/NostoProductRecommendationsSection'
import { ErrorViewHead, ErrorViewSection } from '../../../brunswick/components/pages/ErrorView'
import { imageSrcs, relativePaths } from '../../../constants/figs'
import { canonicalBaseUrls } from '../../../constants/figs'

import { useTrackPageView } from './../../_providers/TrackingProvider.client'
import { useTranslation } from './../../_providers/TranslationProvider.client'

export const NotFoundPage = () => {
  const {
    pages: {
      notFound: { canonicalPath: canonical404Path },
    },
  } = useTranslation()

  return (
    <>
      <ErrorViewHead canonicalUrl={`${canonicalBaseUrls.home}${canonical404Path}`} />
      <NotFoundPageContents />
    </>
  )
}

export const NotFoundPageContents = () => {
  useTrackPageView({
    pageViewHandle: 'Not Found',
    pageViewCategory: 'not found',
  })

  const {
    pages: {
      notFound: {
        image: { alt },
        links,
        subheading,
        heading,
      },
    },
  } = useTranslation()

  const orderedLinks = useMemo(() => {
    return [
      {
        href: relativePaths.shopWomensBestSellersPath,
        title: links.shopWomen.title,
      },
      {
        href: relativePaths.shopMensBestSellersPath,
        title: links.shopMen.title,
      },
    ]
  }, [links.shopMen, links.shopWomen])

  return (
    <>
      <ErrorViewSection
        heading={heading}
        subheading={subheading}
        imageAlt={alt}
        imageSrc={imageSrcs.notFound}
        links={orderedLinks}
      />

      <NostoProductRecommendationsSection
        analyticsContext={{ category: 'not-found-page::notfound-nosto-2' }}
        nostoPlacementId='notfound-nosto-2'
      />

      <NostoProductRecommendationsSection
        analyticsContext={{ category: 'not-found-page::notfound-nosto-1' }}
        nostoPlacementId='notfound-nosto-1'
      />
    </>
  )
}
